import { useEffect } from "react";
import { keepSessionAlive } from "../services/auth/session-keeper";

const CHECK_EVERY_MS = 30 * 60 * 1000;

/**
 * Renders nothing. Keeps a signed-in person's session fresh: checks when the app opens, every half hour, and
 * whenever the tab comes back to the front (a phone that was asleep for hours, say).
 */
export default function SessionKeeper() {
  useEffect(() => {
    const check = async () => {
      const result = await keepSessionAlive();
      if (result === "renewed" || result === "upgraded") {
        window.dispatchEvent(new Event("puck-pickup-auth-change"));
      }
    };

    check();
    const timer = setInterval(check, CHECK_EVERY_MS);
    const onVisible = () => {
      if (document.visibilityState === "visible") check();
    };
    document.addEventListener("visibilitychange", onVisible);
    return () => {
      clearInterval(timer);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, []);

  return null;
}
